import { Button } from '@mui/material'

function SecondaryButtonWithStartIcon({
    onClick,
    startIcon,
    children,
    width,
    bold=false,
    color='#4338CA',
    backgroundColor='#EEF2FF',
    hoverColor='#E0E7FF',
    disabled=false,
    sx={}
}) {
    const defaultSx = {
        width: width,
        height: '30px',
        backgroundColor: backgroundColor,
        color: color,
        border: 'none',
        borderRadius: '6px',
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: bold ? 700 : 500,
        textTransform: 'none',
        justifyContent: 'flex-start',
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
        '&:hover': {
            backgroundColor: hoverColor,
            boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.1)'
        },
        '& .MuiButton-startIcon': {
            marginRight: '6px',
            fontSize: '14px',
            color: color
        }
    }
    return (
        <Button
            onClick={onClick}
            startIcon={startIcon}
            disabled={disabled}
            sx={{
                ...defaultSx,
                '&:hover': {
                    backgroundColor: hoverColor,
                    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.1)'
                },
                ...sx,
            }}
        >
            {children}
        </Button>
    )
}

function SecondaryButton({
    onClick,
    children,
    width,
    bold=false,
    color='#4338CA',
    backgroundColor='#EEF2FF',
    hoverColor='#E0E7FF',
    disabled=false,
    sx={}
}) {
    const defaultSx = {
        width: width,
        height: '30px',
        backgroundColor: backgroundColor,
        color: color,
        border: 'none',
        borderRadius: '4px',
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: bold ? 700 : 500,
        textTransform: 'none',
        justifyContent: 'center',
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
        '&:hover': {
            backgroundColor: hoverColor,
            boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.1)'
        }
    }
    return (
        <Button
            onClick={onClick}
            disabled={disabled}
            sx={{
                ...defaultSx,
                '&:hover': {
                    backgroundColor: hoverColor,
                    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.1)'
                },
                ...sx,
            }}
        >
            {children}
        </Button>
    )
}

export function SecondaryButtonFactory({
    disabled=false,
    onClick,
    startIcon,
    children,
    size='m',
    bold=false,
    buttonColor='blue',
    fullSize=false,
    width,
    sx={}
}) {
    let buttonWidth = fullSize ? '100%' : width ? width : bold ? '103px' : '93px'
    let color = '#4338CA'
    let backgroundColor = '#EEF2FF'
    let hoverColor = '#E0E7FF'

    if (fullSize) {
        buttonWidth = '100%'
    } else if (width) {
        buttonWidth = width
    } else {
        switch (size) {
            case 's':
                buttonWidth = bold ? '81px' : '71px'
                break
            case 'm':
                buttonWidth = bold ? '103px' : '93px'
                break
            case 'l':
                buttonWidth = bold ? '115px' : '105px'
                break
        }
    }   

    console.log('buttonWidth', buttonWidth)

    switch (buttonColor) {
        case 'green':
            color = '#059669'
            backgroundColor = '#D1FAE5'
            hoverColor = '#A7F3D0'
            break
        case 'blue':
            color = '#4338CA'
            backgroundColor = '#EEF2FF'
            hoverColor = '#E0E7FF'
            break
        case 'red':
            color = '#DC2626'
            backgroundColor = '#FEE2E2'
            hoverColor = '#FECACA'
            break
    }

    return (
        startIcon ? (
            <SecondaryButtonWithStartIcon
                disabled={disabled}
                onClick={onClick}
                startIcon={startIcon}
                width={buttonWidth}
                bold={bold}
                color={color}
                backgroundColor={backgroundColor}
                hoverColor={hoverColor}
                sx={sx}
            >
                {children}
            </SecondaryButtonWithStartIcon>
        ) : (
            <SecondaryButton
                disabled={disabled}
                onClick={onClick}
                width={buttonWidth}
                bold={bold}
                color={color}
                backgroundColor={backgroundColor}
                hoverColor={hoverColor}
                sx={sx}
            >
                {children}
            </SecondaryButton>
        )
    )
}